import React from "react";
import { Card, Flex, Heading, Badge, Button } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import CareNotesCard from "../common/CareNotesCard";
import { useMedicalConditionDeleteMutation } from "./api/useMedicalConditionMutation";

export default function MedicalConditionCard({ data }) {
  const navigate = useNavigate();
  const tagsParsed = JSON.parse(data?.tags);
  const { mutate: medicalConditionDelete } =
    useMedicalConditionDeleteMutation();

  return (
    <Card variation="elevated" key={`mcc_d_${data?.id}`}>
      <Flex direction="row" alignItems="center">
        <Heading level="5" children={data?.diagnosisName}></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate(`/user/hr/medical-problems/${data.id}/edit`)}
        >
          Edit
        </Button>
        <Button
          size="small"
          variation="destructive"
          onClick={() => medicalConditionDelete(data.id)}
        >
          Delete
        </Button>
      </Flex>
      <Flex marginTop={12} wrap={"wrap"}>
        <Badge size="small">Last Modified: {data.updatedAt}</Badge>
        {!!data.startDate && (
          <Badge size="small">Start Date: {data.startDate}</Badge>
        )}
      </Flex>
      <Flex marginTop={12} wrap={"wrap"}>
        {tagsParsed.map((tag, index) => {
          return (
            <Badge key={`mcc_mcl_rt_${index}`} size="small" variation="warning">
              {tag}
            </Badge>
          );
        })}
      </Flex>

      <Flex direction={"column"} marginTop={12}>
        <CareNotesCard
          noteSection="HR_MEDICAL_CONDITIONS"
          objectId={data?.id}
        />
      </Flex>
    </Card>
  );
}
